/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var NotificationDark = function NotificationDark(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Notification icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--notificationdark--linear-gradient', 'icon--notificationdark--linear-gradient-2', 'icon--notificationdark--linear-gradient-3', 'icon--notificationdark--linear-gradient-4'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--notificationdark--linear-gradient'],
    x1: "30.05",
    x2: "35.5",
    y1: "54.31",
    y2: "54.31",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--notificationdark--linear-gradient-2'],
    x1: "28.61",
    x2: "70.69",
    y1: "-3.97",
    y2: "68.92",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".52",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".61",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--notificationdark--linear-gradient-3'],
    x1: "38.01",
    x2: "38.01",
    y1: "69.51",
    y2: "-.42",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--notificationdark--linear-gradient-4'],
    x1: "15.14",
    x2: "63.06",
    y1: "5.72",
    y2: "33.52",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".78",
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".81",
    stopColor: "#6c6c6c",
    stopOpacity: ".96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".85",
    stopColor: "#636363",
    stopOpacity: ".84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".89",
    stopColor: "#545454",
    stopOpacity: ".64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".93",
    stopColor: "#404040",
    stopOpacity: ".35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".97",
    stopColor: "#262626",
    stopOpacity: "0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.13 52.11l45.5 26.28 4.25-2.51L19.4 49.63l-4.27 2.48z",
    opacity: ".25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--notificationdark--linear-gradient'], ")"),
    d: "M32.66 52.85l-2.25 4.22a1.14 1.14 0 01-.36.35l2.83-1.65a1.15 1.15 0 00.36-.35l2.26-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--notificationdark--linear-gradient-2'], ")"),
    d: "M63.45 26.58L20.63 1.86a1 1 0 00-1.01-.1l-3.98 2.3a1 1 0 011.02.1l42.82 24.72a3.15 3.15 0 011.42 2.46l-.1 36.09a1 1 0 01-.42.9l3.97-2.3a1 1 0 00.42-.9l.1-36.08a3.15 3.15 0 00-1.42-2.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--notificationdark--linear-gradient-3'], ")"),
    d: "M59.48 28.88a3.15 3.15 0 011.42 2.46l-.1 36.09c0 .9-.65 1.26-1.42.81l-26.7-15.4-2.26 4.23a.9.9 0 01-1.33.27 3.09 3.09 0 01-1.22-1.53l-2.33-7.09-9-5.2a3.14 3.14 0 01-1.42-2.46l.1-36.08c0-.9.64-1.28 1.43-.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M57.99 37.07l-.01 3.9L18.03 17.9l.01-3.9 39.95 23.07zM57.99 45.11l-.01 3.91-39.95-23.07.01-3.9 39.95 23.06zM44.62 45.04l-.01 3.9L18.03 33.6l.01-3.9 26.58 15.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--notificationdark--linear-gradient-4'], ")"),
    d: "M60.76 30.55a2.5 2.5 0 01.14.8v3.95a3.98 3.98 0 01.4-.13l.01-3.82a3.54 3.54 0 00-1.62-2.82L16.86 3.8a1.98 1.98 0 00-.44-.2l-.78.46.03-.01a.72.72 0 01.18-.07h.02a.82.82 0 01.15-.02h.1a1.09 1.09 0 01.23.06l.04.01a1.65 1.65 0 01.27.12l21.4 12.37 21.42 12.36a3.15 3.15 0 011.28 1.67z"
  }));
};
NotificationDark.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var NotificationDark$1 = NotificationDark;

export { NotificationDark$1 as default };
